import { useFm } from '@web3/base-hooks';
import { Button } from '@bfe/moly';
import cls from 'classnames';
import { useWallet } from '@/hooks/wallet';

import styles from './index.module.less';

interface IProps {
  loginText?: string;
}

export const WalletButton = ({ loginText }: IProps) => {
  const fm = useFm();
  const { openLoginModal } = useWallet();

  const handleClick = () => {
    openLoginModal();
  };

  return (
    <div
      className={cls(
        'break-word w100 flex-col-center flex-items-center',
        styles.web3Btn
      )}
    >
      <Button
        size="x-small"
        variant="secondary"
        className="position-absolute"
        onClick={handleClick}
      >
        {fm('investmentDetail')}
      </Button>
    </div>
  );
};
